import React, { useEffect, useState, useRef, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Cookies from 'universal-cookie';
import { ButtonTestCss } from '../../ButtonStyle';
import { Requestdynamic } from '../../Network/Fetch';
import { CssTextField } from './Style';
import Button from 'react-bootstrap/Button';
import { Form, InputGroup } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

const SelectEventModal = ({ show, onClose, onSelect, injectedSearch }) => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [lastKey, setLastKey] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [searching, setSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [injectedSearchState, setInjectedSearchState] = useState(null);
  const loaderRef = useRef();

  const fetchEvents = useCallback(async (reset = false) => {
    try {
      setLoading(true);
      const cookies = new Cookies();
      const Jwt = cookies.get('acces');

      const Params = {
        Body: {
          Jwt,
          NumberOfResult: "20",
          SizeImage: "Small",
          OnlyWithoutGallery: true,
          ...(lastKey && !reset ? { LastKey: lastKey } : {})
        }
      };

      const res = await Requestdynamic('_getAllPassedEvent', Params);
      if (res.error || res.data.error) {
        setError("Erreur lors du chargement des événements.");
        return;
      }

      const newEvents = res.data.data || [];
      setEvents(prev => reset ? newEvents : [...prev, ...newEvents]);
      setLastKey(res.data.LastKey || null);
    } catch (e) {
      setError("Erreur inattendue.");
    } finally {
      setLoading(false);
    }
  }, [lastKey]);

  const searchEvents = async () => {
    if (!search || search.length < 3) return;
    try {
      setSearching(true);
      setHasSearched(true);
      setError(null);
      const cookies = new Cookies();
      const Jwt = cookies.get('acces');

      const res = await Requestdynamic('_searchPassedEvent', {
        Jwt,
        Search: search,
        SizeImage: 'Small',
        OnlyWithoutGallery: true
      });

      if (res.error || res.data.error) {
        setError("Aucun résultat trouvé.");
        setEvents([]);
        return;
      }

      setEvents(res.data.data || []);
      setLastKey(null);
    } catch (e) {
      setError("Erreur lors de la recherche.");
    } finally {
      setSearching(false);
    }
  };

  const handleConfirm = () => {
    const selected = events.find(e => e.Id === selectedId);
    if (selected) {
      onSelect(selected);
      handleClose();
    }
  };

  const handleClose = () => {
    setEvents([]);
    setLastKey(null);
    setSelectedId(null);
    setSearch('');
    setError(null);
    setSearching(false);
    setHasSearched(false);
    setInjectedSearchState(null)
    onClose();
  };

  useEffect(() => {
    if (injectedSearch && injectedSearch !== search) {
      setSearch(injectedSearch);
      setInjectedSearchState(injectedSearch);
    }
  }, [injectedSearch]);

  useEffect(() => {
  if (injectedSearchState && search === injectedSearchState) {
    searchEvents();
    setInjectedSearchState(null);
  }
}, [search, injectedSearchState]);

useEffect(() => {
  if (show && !search && !injectedSearch) {
    setEvents([]);
    setLastKey(null);
    fetchEvents(true);
  }
}, [show, search, injectedSearch]);

  useEffect(() => {
    if (search === '' && hasSearched) {
      setEvents([]);
      setLastKey(null);
      fetchEvents(true);
      setHasSearched(false);
    }
  }, [search, hasSearched]);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && lastKey && !loading && !searching) {
        fetchEvents();
      }
    }, { threshold: 1 });

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [loaderRef.current, lastKey, loading, searching]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      backdrop="true"
      keyboard={false}
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Sélectionner un événement</Modal.Title>
      </Modal.Header>

      <div className="px-3 pb-2 mt-3">
  <InputGroup>
    <Form.Control
      type="text"
      style={{ boxShadow: 'none', outline: 'none' }}
      placeholder="Rechercher un événement (min 3 caractères)"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      onKeyPress={(e) => {
        if (e.key === 'Enter' && search.length >= 3 && !searching) searchEvents();
      }}
    />
    <Button
      variant="outline-secondary"
      onClick={searchEvents}
      disabled={search.length < 3 || searching}
    >
      {searching ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <FaSearch size="0.9em" />
      )}
    </Button>
  </InputGroup>
</div>

      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
        {loading && events.length === 0 ? (
          <div className="text-center"><Spinner animation="border" /><p>Chargement...</p></div>
        ) : error ? (
          <p className="text-danger text-center">{error}</p>
        ) : (
          <div className="d-flex flex-column gap-2">
          {events.length === 0 && hasSearched && !searching ? (
<div className="text-center text-muted py-3">
  Aucun événement trouvé.
</div>
) : (
events.map((event) => (
  <div
    key={event.Id}
    onClick={() => setSelectedId(event.Id)}
    className={`card px-3 py-2 d-flex flex-row align-items-center shadow-sm ${selectedId === event.Id ? 'border border-warning' : ''}`}
    style={{
      cursor: 'pointer',
      minHeight: '80px',
      transition: 'all 0.2s ease-in-out'
    }}
    onMouseEnter={(e) => e.currentTarget.classList.add('shadow-lg')}
    onMouseLeave={(e) => e.currentTarget.classList.remove('shadow-lg')}
  >
    <div style={{ width: '80px', height: '60px', overflow: 'hidden', borderRadius: '5px', marginRight: '15px' }}>
      <img
        src={event.Image}
        alt={event.Name}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </div>
    <div>
      <h6 className="mb-1">{event.Name}</h6>
      <small className="text-muted">{event.DateEvent}</small>
    </div>
  </div>
))
)}
            {lastKey && !search && (
              <div ref={loaderRef} className="text-center py-3">
                <Spinner animation="border" size="sm" />
              </div>
            )}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <ButtonTestCss
          color="orange"
          disabled={!selectedId}
          onClick={handleConfirm}
        >
          Confirmer
        </ButtonTestCss>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectEventModal;
